import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { H3, P } from "../../AbstractElements";
import { getTimeLogForBooking } from "../../Services/Booking.service";
import TimeLogIcons from "../../CommonElements/TimeLogIcons";
import {
  useParams
} from "react-router-dom";
import moment from "moment";
const TimeLog = () => {
  const [bookingTimeLineData, setBookingTimeLineData] = useState([]);
  const {bookingNumber} =useParams();
  useEffect(() => {
    const body = {
      bookingNumber,
    };
    getTimeLogForBooking(body).then((result) => {
      let processData = [];
      if (result.data.length > 0) {
        result.data.forEach((element) => {
          processData.push({
            headingClass: "activity-dot-secondary",
            heading: element.activity,
            desc: element.postedOn
              ? moment(new Date(element.postedOn)).format("MMM DD HH:mm:ss")
              : "-",
          });
        });
        processData[0]["line"] = true;
      }
      setBookingTimeLineData(processData);
    });
  }, []);

  return (
    <Container fluid={true}>
      <div className="page-title">
        <Row>
          <Col xs="12">
            <H3>{"Time Log"}</H3>
          </Col>
        </Row>
      </div>
      <div className="activity-timeline">
        {bookingTimeLineData.map((news, i) => (
          <div className="media" key={i}>
            {news.line && <div className="activity-line"></div>}
            {/* <div className={news.headingClass}></div> */}
            <TimeLogIcons timeLogType={news.heading} />
            <div>
              <img src="" alt="" />
            </div>
            <div className="media-body">
              <span>
                {news.heading}
              </span>
              <P attrPara={{ className: "font-roboto" }}>{news.desc}</P>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default TimeLog;
